<div class="overflow-hidden relative z-10 max-w-full">
    <router-outlet></router-outlet>
</div>
